import React, { Suspense, useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import "react-datepicker/dist/react-datepicker.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";

import "react-pagination-js/dist/styles.css";
import "react-toastify/dist/ReactToastify.css";
import "react-phone-input-2/lib/style.css";

import { createBrowserHistory } from "history";
export const history = createBrowserHistory();
import Home from "./pages/Home/Home.jsx";
import BrowserProducts from "./pages/Products/BrowserProducts.jsx";
import ProductDetail from "./pages/Products/ProductDetail.jsx";
import ContactUs from "./pages/ContactUs/ContactUs.jsx";
import AboutUS from "./pages/AboutUs/Aboutus.jsx";
import PaymentConfirmed from "./pages/ThankyouPage.jsx";
import Login from "./methods/auth/login.jsx";
import Cart from "./pages/Cart/Cart.jsx";
import Signup from "./methods/auth/signup.jsx";
import Forgot from "./methods/auth/forgot.jsx";
import Reset from "./methods/auth/reset.jsx";
import PaymentFailed from "./pages/OrderStatus/PaymentFailed.jsx";
import OrderConfirmed from "./pages/OrderStatus/OrderConfirmed.jsx";
import ChangePassword from "./pages/Profile/ChangePassword.jsx";
import Profile from "./pages/Profile/Profile.jsx";
import EditProfile from "./pages/Profile/EditProfile.jsx";
import Dashboard from "./pages/dashboard";
import Orders from "./pages/Orders";
import ActionStatus from "./pages/AcceptReject/index.js";
import GuestOrderTracking from "./pages/TrackOrder/index.js";
import Hometwo from "./pages/Home/Hometwo.jsx";
import PrivacyPolicy from "./pages/PrivacyPolicy/PrivacyPolicy.jsx";
import TermsAndConditions from "./pages/TermsAndConditions/TermsAndConditions.jsx";
import EstimateStatus from "./pages/EstimateStatus/index.js";
import OrderTrackingDetail from "./pages/OrderTracking/OrderTrackingDetail.jsx";
import CreateNewPassword from "./pages/Profile/CreateNewPassword.jsx";
import QuickBookEstimateDetailCustomer from "./pages/QuickBooks/QuickBookEstimateDetailCustomer.jsx";
import QuickBookInvoiceDetailCustomer from "./pages/QuickBooks/QuickBookInvoiceDetailCustomer.jsx";
import RouteTitle from "./RouteTitle";
import NoPages from "./pages/404/index.js";

export default () => {
  const hostname = window.location.hostname;
  const subDomain = "logistics.charlessmithassociates.com";
  // const subDomain = "localhost";

  return (
    <>
      <Suspense
        fallback={
          <div>
            <div id="loader" className="loaderDiv">
              <div>
                <img
                  src="/assets/img/loader.gif"
                  alt="logo"
                  className="pageLoader"
                  width="auto"
                  height="auto"
                />
              </div>
            </div>
          </div>
        }
      >
        <Router>
          <ScrollToTop />
          <RouteTitle />
          <Routes>
            <Route
              path="/"
              element={hostname === subDomain ? <Hometwo /> : <Home />}
            />
            <Route path="/products" element={<BrowserProducts />} />
            <Route path="/products/detail" element={<ProductDetail />} />
            <Route path="/contact/us" element={<ContactUs />} />
            <Route path="/about/us" element={<AboutUS />} />
            <Route path="/thankyou" element={<PaymentConfirmed />} />
            <Route path="/action" element={<ActionStatus />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/orders" element={<Orders />} />

            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/forgotpassword" element={<Forgot />} />
            <Route path="/reset-password" element={<Reset />} />
            <Route path="/changepassword" element={<ChangePassword />} />
            <Route path="/create-password" element={<CreateNewPassword />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/payment/failed" element={<PaymentFailed />} />
            <Route path="/order/confirmed" element={<OrderConfirmed />} />
            <Route path="/estimate/status" element={<EstimateStatus />} />
            <Route
              path="/order/tracking/detail/:id"
              element={<OrderTrackingDetail />}
            />
            <Route
              path="/estimate/detail/:id"
              element={<QuickBookEstimateDetailCustomer />}
            />
            <Route
              path="/invoice/detail/:id"
              element={<QuickBookInvoiceDetailCustomer />}
            />
            <Route path="/profile" element={<Profile />} />
            <Route path="/editprofile" element={<EditProfile />} />
            <Route path="/track/orders" element={<GuestOrderTracking />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route
              path="/terms-and-conditions"
              element={<TermsAndConditions />}
            />
            <Route path="*" element={<NoPages />} />
          </Routes>
        </Router>
      </Suspense>
      <div id="loader" className="loaderDiv !hidden">
        <div>
          <img
            src="/assets/img/loader.gif"
            width="auto"
            height="auto"
            alt="logo"
            className="pageLoader"
          />
        </div>
      </div>
      <ToastContainer />
    </>
  );
};
